import axios, { AxiosRequestConfig } from 'axios';

import { AnonymousParent } from '../types';
import { DataResponse } from '../types/api';

const URL = '/v2/public/anonymous-parents';

class AnonymousParentService {
  static findByUuid(
    uuid: string,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AnonymousParent>> {
    return axios.get(`${URL}/${uuid}`, config);
  }

  static create(
    data: AnonymousParent,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AnonymousParent>> {
    return axios.post(URL, data, config);
  }

  static update(
    uuid: string,
    data: AnonymousParent,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AnonymousParent>> {
    return axios.post(`${URL}/${uuid}`, data, config);
  }
}

export { AnonymousParentService };
